
const RadioButtonGroup = ({ options, value, onChange }) => {
  return (
    <div className="btn-group pb-2" role="group">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`btn ${
            value === option.value ? "btn-outline-primary active" : "btn-outline-secondary"
          }`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default RadioButtonGroup;
